module.exports = __webpack_public_path__ + "static/media/Sanjay-Bakshi.cd684f24.png";